
import React, { lazy, Suspense } from 'react';

interface LazyLoadProps {
  children: React.ReactNode;
}

// Improved loading fallback with smaller footprint
const Loading = () => <div className="p-4 text-center text-sm">Carregando...</div>;

// Enhanced HOC for lazy loading components with better error handling
export function lazyLoad(importFunc: () => Promise<{ default: React.ComponentType<any> }>) {
  const LazyComponent = lazy(importFunc);
  
  return (props: any) => (
    <Suspense fallback={<Loading />}>
      <LazyComponent {...props} />
    </Suspense>
  );
}

// Wrapper component for lazy loading with options for different fallbacks
export const LazyLoadWrapper = ({ children }: LazyLoadProps) => (
  <Suspense fallback={<Loading />}>
    {children}
  </Suspense>
);

// Image lazy loader with width and height attributes
export const LazyImage = ({ 
  src, 
  alt, 
  width, 
  height, 
  className = "" 
}: { 
  src: string; 
  alt: string; 
  width: number; 
  height: number; 
  className?: string;
}) => {
  return (
    <img 
      src={src} 
      alt={alt} 
      width={width} 
      height={height} 
      loading="lazy" 
      className={className} 
      decoding="async"
    />
  );
};
